import { action, computed, observable } from 'mobx';
import { observer } from 'mobx-react';
import * as React from 'react';
import { bind } from '../Utils/Bind';
import { BsXCircle } from '@react-icons/all-files/bs/BsXCircle';

export class AlertHandle {
    @bind
    @action
    public close() {
        this.isOpen = false;
    }

    @bind
    @action
    public onToggle() {
        this.isOpen = !this.isOpen;
    }

    @bind
    @action
    public set(
        color: 'teal' | 'info' | 'success' | 'danger' | 'warning',
        message: string,
        timeout?: number,
        showClose?: boolean
    ) {
        if (this.timeoutHandle) {
            window.clearTimeout(this.timeoutHandle);
        }

        if (showClose) this.showClose = showClose;

        if (timeout) {
            this.timeoutHandle = window.setTimeout(this.close, timeout);
        }

        this.color = color;
        this.message = message;
        this.isOpen = true;
    }

    @bind
    public setError(error: any, persistant?: boolean) {
        const message =
            typeof error == 'string'
                ? error
                : typeof error == 'object' && typeof error.message == 'string'
                    ? error.message
                    : 'An error has occured. Please try again.';
        const timeout = persistant ? undefined : 10000;

        this.set('danger', message, timeout, true);
    }

    @observable
    public isOpen = false;

    @observable
    public message: string = 'This is a test of the alert system.';

    @observable
    public color: 'teal' | 'info' | 'success' | 'danger' | 'warning' = 'info';

    @observable
    public showClose: boolean = true;

    private timeoutHandle?: number;
}

export interface IAlertProps {
    readonly alertHandle: AlertHandle;
    readonly className?: string;
    readonly color?: 'teal' | 'info' | 'success' | 'danger' | 'warning';
}

@observer
export class Alert extends React.Component<IAlertProps> {
    public render() {
        return (
            <div className={' notification-alert text-center p-2 text-white ' + this.alertClass}>
                <p className="m-0 d-inline-block p-2"> {this.props.alertHandle.message}</p>

                {this.props.alertHandle.showClose && (
                    <a className="btn btn-link float-end" onClick={this.props.alertHandle.close}>
                        <BsXCircle color="white" />
                    </a>
                )}
            </div>
        );
    }

    @computed
    private get alertClass() {
        if (this.props.alertHandle.isOpen) {
            return 'bg-' + this.props.alertHandle.color + ' slide-in';
        }

        return 'slide-out';
    }
}
